/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Error_ActionInputs */



/**
* | output |
* | --- |
* | "Action failed" |
*
* @param {Tournament_Error_ActionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_error_action = /** @type {((inputs?: Tournament_Error_ActionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Error_ActionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'action a échoué")
	if (locale === "es") return /** @type {LocalizedString} */ ("Acción fallida")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ação falhou")
	if (locale === "it") return /** @type {LocalizedString} */ ("Azione fallita")
	return /** @type {LocalizedString} */ ("Action failed")
});